// extracted by mini-css-extract-plugin
module.exports = {"service-list":"_14HUuVfdnc4AJG5UmNu6n_ _1K4srFNqEJbMjShu71Pk0U","service":"_34lU9oQ1EIfUgiraM7rHE7 _3_q-ocebFWCD6oNq1wyzkB"};